export enum TimeFrame {
    Daily,
    Weekly,
    Monthly
}